// Removed unused import 'moment'

export interface IMco {
    id: number;
    practice_id: number;
    month: string;
    metrics: string;
    mco: number;
    mco_id:number;
    mco_name: string;
    /** Report family this MCO entry belongs to: GIC | RA | APPT | MWOVS | SIIP | TSM | CIS | IMA | W30 */
    type?: string;
    gic: number;
    gic_qty: number;
    gic_complete: number;
    ra: number;
    ra_qty: number;
    ra_present: number;
    nu: number;
    nu_qty: number;
    nu_nom_users: number;
  }

  export class Mco  {
    id: number;
    practiceId: number;
    mcoId:number;
    month: string;
    metrics: string;
    mco: number;
    mcoName: string;
    /** Optional report family tag returned by the combined dashboardMcoList endpoint. */
    type?: string;
    gic: number;
    ra: number;
    nu: number;


    constructor(data?: IMco) {
      this.id = data?.id ?? 0;
      this.practiceId = data?.practice_id ?? 0;
      this.mcoId = data?.mco_id??0;
      this.month = data?.month ?? '';
      this.metrics = data?.metrics ?? '';
      this.mco = data?.mco ?? 0;
      this.mcoName = data?.mco_name ?? '';  // Corrected property name to match interface
      this.type = data?.type ?? '';
      this.gic = data?.gic ?? 0;
      this.ra = data?.ra ?? 0;
      this.nu = data?.nu ?? 0;
    }

    static fromObjectArray(invitations: IMco[]): Mco[] {
      return invitations.map(inv => new Mco(inv));
    }
  }

  export interface IResultMcoModel {
    count: number;
    next: string;
    previous: string;
    results: IMco[];
  }

  export class ResultMcoModel {
    count: number = 0;
    next: string;
    previous: string;
    results: Mco[] = [];

    constructor(result?: IResultMcoModel) {
      if (result) {
        this.count = result?.count ?? 0;
        this.next = result.next ?? '';
        this.previous = result.previous ?? '';
        this.results = Mco.fromObjectArray(result.results ?? []);
      }
      else{
        this.count =0;
        this.next = ''
        this.previous = ''
        this.results = []
      }
    }
  }
